// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/proposal_pricing_ratebook.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { RateBookSuggestion, RateObservationRef } from "../../datagateway/v1/proposal_pricing_pb";
/**
 * @generated from message mono.projectdata.v1.PricingLink
 */ export class PricingLink extends Message {
    static fromBinary(bytes, options) {
        return new PricingLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingLink, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string lcat_logical_key = 1;
   */ _define_property(this, "lcatLogicalKey", ""), /**
   * @generated from field: string as_written_title = 2;
   */ _define_property(this, "asWrittenTitle", ""), /**
   * @generated from field: string entry_id = 3;
   */ _define_property(this, "entryId", ""), /**
   * @generated from field: string entry_title = 4;
   */ _define_property(this, "entryTitle", ""), /**
   * "/registries/labor-categories/entries/{entry_id}"
   *
   * @generated from field: string entry_href = 5;
   */ _define_property(this, "entryHref", ""), /**
   * @generated from field: string mapping_status = 6;
   */ _define_property(this, "mappingStatus", ""), /**
   * @generated from field: string match_basis = 7;
   */ _define_property(this, "matchBasis", ""), /**
   * @generated from field: string entry_vehicle_name = 8;
   */ _define_property(this, "entryVehicleName", ""), /**
   * @generated from field: string decision = 9;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: string source_vehicle_id = 10;
   */ _define_property(this, "sourceVehicleId", ""), /**
   * @generated from field: string source_vehicle_name = 11;
   */ _define_property(this, "sourceVehicleName", ""), /**
   * @generated from field: string decision_reason = 12;
   */ _define_property(this, "decisionReason", ""), /**
   * @generated from field: string decided_by_name = 13;
   */ _define_property(this, "decidedByName", ""), /**
   * @generated from field: string decided_at = 14;
   */ _define_property(this, "decidedAt", ""), /**
   * status in (UNMAPPED, VEHICLE_MISMATCH, REVIEW_NEEDED) && decision == "" && !removed
   *
   * @generated from field: bool needs_decision = 15;
   */ _define_property(this, "needsDecision", false), /**
   * @generated from field: bool removed = 16;
   */ _define_property(this, "removed", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingLink, "runtime", proto3);
_define_property(PricingLink, "typeName", "mono.projectdata.v1.PricingLink");
_define_property(PricingLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "lcat_logical_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "as_written_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "entry_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "entry_href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "mapping_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "match_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "entry_vehicle_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "source_vehicle_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "decision_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "decided_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "decided_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "needs_decision",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 16,
            name: "removed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PricingUsingView
 */ export class PricingUsingView extends Message {
    static fromBinary(bytes, options) {
        return new PricingUsingView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingUsingView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingUsingView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingUsingView, a, b);
    }
    constructor(data){
        super(), /**
   * effective; "" = Choose
   *
   * @generated from field: string amount = 1;
   */ _define_property(this, "amount", ""), /**
   * suggestion|observation|manual|workbook|seeded_government|seeded_ceiling|escalated|adjusted_suggestion|""
   *
   * @generated from field: string basis = 2;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string set_by_name = 4;
   */ _define_property(this, "setByName", ""), /**
   * @generated from field: string set_at = 5;
   */ _define_property(this, "setAt", ""), /**
   * @generated from field: string escalated_from_period_key = 6;
   */ _define_property(this, "escalatedFromPeriodKey", ""), /**
   * ""|CORRECTED|INVALIDATED|NEWER_EVIDENCE
   *
   * @generated from field: string selection_review_status = 7;
   */ _define_property(this, "selectionReviewStatus", ""), /**
   * @generated from field: bool differs_from_suggestion = 8;
   */ _define_property(this, "differsFromSuggestion", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingUsingView, "runtime", proto3);
_define_property(PricingUsingView, "typeName", "mono.projectdata.v1.PricingUsingView");
_define_property(PricingUsingView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "set_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "set_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "escalated_from_period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "selection_review_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "differs_from_suggestion",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PricingAdjustmentView
 */ export class PricingAdjustmentView extends Message {
    static fromBinary(bytes, options) {
        return new PricingAdjustmentView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingAdjustmentView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingAdjustmentView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingAdjustmentView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * scenario|period|category|cell
   *
   * @generated from field: string scope = 2;
   */ _define_property(this, "scope", ""), /**
   * "All labor categories"|"Option 1"|"Program Manager"|"Program Manager · Option 1"
   *
   * @generated from field: string scope_label = 3;
   */ _define_property(this, "scopeLabel", ""), /**
   * "-3.00"
   *
   * @generated from field: string pct = 4;
   */ _define_property(this, "pct", ""), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string set_by_name = 6;
   */ _define_property(this, "setByName", ""), /**
   * @generated from field: string set_at = 7;
   */ _define_property(this, "setAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingAdjustmentView, "runtime", proto3);
_define_property(PricingAdjustmentView, "typeName", "mono.projectdata.v1.PricingAdjustmentView");
_define_property(PricingAdjustmentView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scope_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "pct",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "set_by_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "set_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PricingRateBookRow
 */ export class PricingRateBookRow extends Message {
    static fromBinary(bytes, options) {
        return new PricingRateBookRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingRateBookRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingRateBookRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingRateBookRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string category_id = 1;
   */ _define_property(this, "categoryId", ""), /**
   * as written
   *
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: mono.projectdata.v1.PricingLink link = 3;
   */ _define_property(this, "link", void 0), /**
   * decimal or ""
   *
   * @generated from field: string hours = 4;
   */ _define_property(this, "hours", ""), /**
   * @generated from field: repeated string hours_clin_numbers = 5;
   */ _define_property(this, "hoursClinNumbers", []), /**
   * @generated from field: mono.datagateway.v1.RateObservationRef ours = 6;
   */ _define_property(this, "ours", void 0), /**
   * @generated from field: string ours_empty_reason = 7;
   */ _define_property(this, "oursEmptyReason", ""), /**
   * @generated from field: mono.datagateway.v1.RateObservationRef teammate = 8;
   */ _define_property(this, "teammate", void 0), /**
   * @generated from field: string teammate_empty_reason = 9;
   */ _define_property(this, "teammateEmptyReason", ""), /**
   * @generated from field: mono.datagateway.v1.RateObservationRef competitor = 10;
   */ _define_property(this, "competitor", void 0), /**
   * @generated from field: string competitor_empty_reason = 11;
   */ _define_property(this, "competitorEmptyReason", ""), /**
   * @generated from field: mono.datagateway.v1.RateBookSuggestion suggested = 12;
   */ _define_property(this, "suggested", void 0), /**
   * @generated from field: mono.projectdata.v1.PricingUsingView using = 13;
   */ _define_property(this, "using", void 0), /**
   * Using x Hours, half-up
   *
   * @generated from field: optional int64 extended_cents = 14;
   */ _define_property(this, "extendedCents", void 0), /**
   * @generated from field: bool removed_from_section_b = 15;
   */ _define_property(this, "removedFromSectionB", false), /**
   * winning entry for this cell; unset = none
   *
   * @generated from field: mono.projectdata.v1.PricingAdjustmentView adjustment = 16;
   */ _define_property(this, "adjustment", void 0), /**
   * "" when no adjustment or requires_choice/NONE
   *
   * @generated from field: string adjusted_amount = 17;
   */ _define_property(this, "adjustedAmount", ""), /**
   * using.basis == adjusted_suggestion && stored adjustedAmount != adjusted_amount
   *
   * @generated from field: bool adjustment_stale = 18;
   */ _define_property(this, "adjustmentStale", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingRateBookRow, "runtime", proto3);
_define_property(PricingRateBookRow, "typeName", "mono.projectdata.v1.PricingRateBookRow");
_define_property(PricingRateBookRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "category_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "link",
            kind: "message",
            T: PricingLink
        },
        {
            no: 4,
            name: "hours",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "hours_clin_numbers",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "ours",
            kind: "message",
            T: RateObservationRef
        },
        {
            no: 7,
            name: "ours_empty_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "teammate",
            kind: "message",
            T: RateObservationRef
        },
        {
            no: 9,
            name: "teammate_empty_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "competitor",
            kind: "message",
            T: RateObservationRef
        },
        {
            no: 11,
            name: "competitor_empty_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "suggested",
            kind: "message",
            T: RateBookSuggestion
        },
        {
            no: 13,
            name: "using",
            kind: "message",
            T: PricingUsingView
        },
        {
            no: 14,
            name: "extended_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ ,
            opt: true
        },
        {
            no: 15,
            name: "removed_from_section_b",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 16,
            name: "adjustment",
            kind: "message",
            T: PricingAdjustmentView
        },
        {
            no: 17,
            name: "adjusted_amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "adjustment_stale",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PricingRateBookCapabilities
 */ export class PricingRateBookCapabilities extends Message {
    static fromBinary(bytes, options) {
        return new PricingRateBookCapabilities().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingRateBookCapabilities().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingRateBookCapabilities().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingRateBookCapabilities, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool can_edit = 1;
   */ _define_property(this, "canEdit", false), /**
   * ABAC ratebook.columns.read
   *
   * @generated from field: bool rate_book_access = 2;
   */ _define_property(this, "rateBookAccess", false), /**
   * view_only|no_pricing_authority|""
   *
   * @generated from field: string read_only_reason = 3;
   */ _define_property(this, "readOnlyReason", ""), /**
   * ABAC pricing.adjustment.write
   *
   * @generated from field: bool can_set_adjustment = 4;
   */ _define_property(this, "canSetAdjustment", false), /**
   * ""|"rule:ratebook.columns.read"
   *
   * @generated from field: string rate_book_denied_reason = 5;
   */ _define_property(this, "rateBookDeniedReason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingRateBookCapabilities, "runtime", proto3);
_define_property(PricingRateBookCapabilities, "typeName", "mono.projectdata.v1.PricingRateBookCapabilities");
_define_property(PricingRateBookCapabilities, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "can_edit",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "rate_book_access",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "read_only_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "can_set_adjustment",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "rate_book_denied_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PricingPeriodView
 */ export class PricingPeriodView extends Message {
    static fromBinary(bytes, options) {
        return new PricingPeriodView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingPeriodView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingPeriodView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingPeriodView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string period_key = 1;
   */ _define_property(this, "periodKey", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: int32 ordinal = 3;
   */ _define_property(this, "ordinal", 0), /**
   * @generated from field: string start_date = 4;
   */ _define_property(this, "startDate", ""), /**
   * @generated from field: string end_date = 5;
   */ _define_property(this, "endDate", ""), /**
   * @generated from field: string escalation_factor = 6;
   */ _define_property(this, "escalationFactor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingPeriodView, "runtime", proto3);
_define_property(PricingPeriodView, "typeName", "mono.projectdata.v1.PricingPeriodView");
_define_property(PricingPeriodView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "escalation_factor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPricingRateBookRequest
 */ export class GetPricingRateBookRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPricingRateBookRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPricingRateBookRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPricingRateBookRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPricingRateBookRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * "" = primary
   *
   * @generated from field: string scenario_id = 2;
   */ _define_property(this, "scenarioId", ""), /**
   * "" = base
   *
   * @generated from field: string period_key = 3;
   */ _define_property(this, "periodKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPricingRateBookRequest, "runtime", proto3);
_define_property(GetPricingRateBookRequest, "typeName", "mono.projectdata.v1.GetPricingRateBookRequest");
_define_property(GetPricingRateBookRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPricingRateBookResponse
 */ export class GetPricingRateBookResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPricingRateBookResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPricingRateBookResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPricingRateBookResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPricingRateBookResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string scenario_id = 1;
   */ _define_property(this, "scenarioId", ""), /**
   * RFC3339Nano, echoed as expected_updated_at by writes
   *
   * @generated from field: string scenario_updated_at = 2;
   */ _define_property(this, "scenarioUpdatedAt", ""), /**
   * @generated from field: repeated mono.projectdata.v1.PricingPeriodView periods = 3;
   */ _define_property(this, "periods", []), /**
   * @generated from field: string period_key = 4;
   */ _define_property(this, "periodKey", ""), /**
   * @generated from field: repeated mono.projectdata.v1.PricingRateBookRow rows = 5;
   */ _define_property(this, "rows", []), /**
   * @generated from field: mono.projectdata.v1.PricingRateBookCapabilities capabilities = 6;
   */ _define_property(this, "capabilities", void 0), /**
   * @generated from field: string rule_note = 7;
   */ _define_property(this, "ruleNote", ""), /**
   * @generated from field: string as_of = 8;
   */ _define_property(this, "asOf", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPricingRateBookResponse, "runtime", proto3);
_define_property(GetPricingRateBookResponse, "typeName", "mono.projectdata.v1.GetPricingRateBookResponse");
_define_property(GetPricingRateBookResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scenario_updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "periods",
            kind: "message",
            T: PricingPeriodView,
            repeated: true
        },
        {
            no: 4,
            name: "period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rows",
            kind: "message",
            T: PricingRateBookRow,
            repeated: true
        },
        {
            no: 6,
            name: "capabilities",
            kind: "message",
            T: PricingRateBookCapabilities
        },
        {
            no: 7,
            name: "rule_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPricingRateBookRowRequest
 */ export class GetPricingRateBookRowRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPricingRateBookRowRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPricingRateBookRowRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPricingRateBookRowRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPricingRateBookRowRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_id = 2;
   */ _define_property(this, "scenarioId", ""), /**
   * @generated from field: string category_id = 3;
   */ _define_property(this, "categoryId", ""), /**
   * @generated from field: string period_key = 4;
   */ _define_property(this, "periodKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPricingRateBookRowRequest, "runtime", proto3);
_define_property(GetPricingRateBookRowRequest, "typeName", "mono.projectdata.v1.GetPricingRateBookRowRequest");
_define_property(GetPricingRateBookRowRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "category_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PricingObservationView
 */ export class PricingObservationView extends Message {
    static fromBinary(bytes, options) {
        return new PricingObservationView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingObservationView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingObservationView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingObservationView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string observation_id = 1;
   */ _define_property(this, "observationId", ""), /**
   * @generated from field: int32 version = 2;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string observation_type = 3;
   */ _define_property(this, "observationType", ""), /**
   * @generated from field: string type_label = 4;
   */ _define_property(this, "typeLabel", ""), /**
   * @generated from field: string amount = 5;
   */ _define_property(this, "amount", ""), /**
   * @generated from field: string rate_unit = 6;
   */ _define_property(this, "rateUnit", ""), /**
   * @generated from field: string company_name = 7;
   */ _define_property(this, "companyName", ""), /**
   * @generated from field: string vehicle_name = 8;
   */ _define_property(this, "vehicleName", ""), /**
   * @generated from field: string period_label = 9;
   */ _define_property(this, "periodLabel", ""), /**
   * @generated from field: string source_label = 10;
   */ _define_property(this, "sourceLabel", ""), /**
   * @generated from field: string role = 11;
   */ _define_property(this, "role", ""), /**
   * @generated from field: bool cross_vehicle = 12;
   */ _define_property(this, "crossVehicle", false), /**
   * @generated from field: string confidence = 13;
   */ _define_property(this, "confidence", ""), /**
   * HOURLY && eligible (S0)
   *
   * @generated from field: bool selectable = 14;
   */ _define_property(this, "selectable", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingObservationView, "runtime", proto3);
_define_property(PricingObservationView, "typeName", "mono.projectdata.v1.PricingObservationView");
_define_property(PricingObservationView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "observation_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "type_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "rate_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "vehicle_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "cross_vehicle",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "selectable",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PricingRowHistoryItem
 */ export class PricingRowHistoryItem extends Message {
    static fromBinary(bytes, options) {
        return new PricingRowHistoryItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingRowHistoryItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingRowHistoryItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingRowHistoryItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string summary = 1;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: string actor_name = 2;
   */ _define_property(this, "actorName", ""), /**
   * @generated from field: string created_at = 3;
   */ _define_property(this, "createdAt", ""), /**
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingRowHistoryItem, "runtime", proto3);
_define_property(PricingRowHistoryItem, "typeName", "mono.projectdata.v1.PricingRowHistoryItem");
_define_property(PricingRowHistoryItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "actor_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPricingRateBookRowResponse
 */ export class GetPricingRateBookRowResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPricingRateBookRowResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPricingRateBookRowResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPricingRateBookRowResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPricingRateBookRowResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.PricingRateBookRow row = 1;
   */ _define_property(this, "row", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.PricingObservationView observations = 2;
   */ _define_property(this, "observations", []), /**
   * newest 20
   *
   * @generated from field: repeated mono.projectdata.v1.PricingRowHistoryItem history = 3;
   */ _define_property(this, "history", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPricingRateBookRowResponse, "runtime", proto3);
_define_property(GetPricingRateBookRowResponse, "typeName", "mono.projectdata.v1.GetPricingRateBookRowResponse");
_define_property(GetPricingRateBookRowResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "row",
            kind: "message",
            T: PricingRateBookRow
        },
        {
            no: 2,
            name: "observations",
            kind: "message",
            T: PricingObservationView,
            repeated: true
        },
        {
            no: 3,
            name: "history",
            kind: "message",
            T: PricingRowHistoryItem,
            repeated: true
        }
    ]));
